import { $win, $body } from "./globals";
import isMobile from "./isMobile";

$win.on("load", function() {
  isMobileDevice();
});

function isMobileDevice() {
  if (isMobile.any()) {
    $body.addClass("mobile-device");
  }
}

export default isMobileDevice;
